<template>
  <div>
    <AccountNavigation v-if="!$smallScreen" />
    <AccountContent />
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import AccountNavigation from '@/components/gambling/AccountNavigation'
import AccountContent from '@/components/gambling/AccountContent'

@Component({
  components: {
    AccountNavigation,
    AccountContent
  }
})
export default class GamblingAccount extends Vue {
  // ...
}
</script>

<style lang="scss" scoped>
</style>